import { useEffect, useState } from 'react';
import { getWorkspaceCommunicationCredits } from 'wisestep-api';

export const useWorkspaceCredit = () => {
  const [credit, setCredit] = useState<number>(0);

  useEffect(() => {
    const fetchCredits = async () => {
      const creditResponse = await getWorkspaceCommunicationCredits();
      setCredit(creditResponse.data.credit);
    };
    fetchCredits();
  }, []);

  return credit;
};
